import { connect } from 'react-redux';

import PropProvider from '../PropProvider';
import LandingPage from '../components/LandingPage';
import { defaultMapDispatchToProps } from '../utils/ConnectDefaults';

export default connect(
  (state) => PropProvider(state).LandingPage(),
  defaultMapDispatchToProps
)(LandingPage);